import React from "react";
import Grid from "@material-ui/core/Grid";
import '../../../App.scss';
import BTN from "../../../assets/images/btns_setting.png";
import SendIcon from "../../../assets/images/send_ic.png";
import {settings} from "../../../Store/Actions/SettingsAction";
import {connect} from "react-redux";
import axios from "axios";
import Snackbar from '@material-ui/core/Snackbar';

import {SETTINGS_FAQ, SETTINGS_RPIVACY, SETTINGS_RULES,SETTINGS_SUPPORT} from "../../../Store/Actions/Types";
import {withRouter} from "react-router-dom";
const backgroundImage = require("../../../assets/images/main_background.png");

class Item extends React.Component{
    constructor() {
        super();
        this.state={
            privacyLoaded:false,
            rulesLoaded:false,
            faqLoaded:false,
            active: false,
            open: false,
            vertical: 'bottom',
            horizontal: 'center',
            snackMessage:''
        }
    }
    loadData= async(type)=>{
        // console.log(type)
        switch (type) {
            case 'contactUs':
                axios.get(`support/get`)
                    .then(res => {
                        const {data}=res
                        this.props.settings(data,SETTINGS_FAQ)
                        const newData=
                            `<div class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-direction-xs-column" id="second" style="flex: 1 1 0%; min-height: 0px;">
                                <div class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-flex-end" id="appendHere" style="overflow-y: scroll; flex: 1 1 0%;">
                                    <div class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-direction-xs-column"  id="me">
                                       <div class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center">
                                            <p class="setting-support-answer">${data.list[0].text}</p>
                                        </div>
                                        ${data.list.slice(1).map(data=>
                                        `<div class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center ${data.answer=='1' ?`MuiGrid-justify-xs-flex-start`:`MuiGrid-justify-xs-flex-end`}">
                                            <p class="${data.answer!=='1'?`setting-support-question`:`setting-support-answer`}">
                                                    ${data.text}
                                                <p class="setting-support-question-detail">
                                                </p>
                                            </p>
                                        </div>`
                                        )} 
                                    </div>
                                </div>
                                <div class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center" id="toolbar">
                                    <div class="MuiGrid-root setting-support-input-section MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center MuiGrid-grid-xs-11 MuiGrid-grid-sm-11">
                                        <div onclick="addMessage()" class="MuiGrid-root setting-support-input-section-image-holder clickable MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-grid-xs-2 MuiGrid-grid-sm-2">
                                            <img src="data:image/png;base64,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" alt="" style="width: 100%;">
                                        </div>
                                        <input style="color: #000000" id="input" type="text" maxlength="10" placeholder="پیغام خود را بنوسید">
                                    </div>
                                </div>
                            </div>`
                        let temp = document.querySelector('.im-dialog-inner .items-section-single-item-content')
                        temp.innerHTML=newData
                    }).catch(error=>{
                    // console.log("failed")
                    // console.log(error.toString())
                    }
                )
                break
            case 'faq':
                axios.get(`app/${type}`)
                    .then(res => {
                        const {data}=res
                        this.props.settings(data,SETTINGS_FAQ)
                        const newData=
                            `<div class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-direction-xs-column" id="second" style="flex: 1 1 0%;overflow-y: scroll; min-height: 0px;">
                                <div class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-flex-end" id="appendHere" style=" flex: 1 1 0%;">
                                ${data.list.map(data=>
                                    `<div class="MuiGrid-root MuiGrid-container MuiGrid-item" id="me">
                                        <div class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-flex-end">
                                            <p class="setting-faq-question" style="background-color: green;">
                                                ${data.question}
                                            </p>
                                        </div>
                                        <div class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center">
                                            <p class="setting-faq-answer" style="background-color: yellow;">
                                                ${data.answer}
                                            </p>
                                        </div>
                                    </div>`
                                )}
                                </div>
                            </div>`
                        let temp = document.querySelector('.im-dialog-inner .items-section-single-item-content')
                        temp.innerHTML=newData
                    }).catch(error=>{
                    // console.log("failed")
                    // console.log(error.toString())
                    }
                )
                break
            case 'rule':{
                axios.get(`app/${type}`)
                    .then(res => {
                        const {data}=res
                        this.props.settings(data,SETTINGS_RULES)
                        const newData=
                            `<div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-direction-xs-column" id="second" style="flex: 1 1 0%;overflow-y: scroll; min-height: 0px;">
                                <div className="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-flex-end"
                                     id="appendHere" style=" flex: 1 1 0%;">
                                    ${data.list.map(data=>
                                `<div class="MuiGrid-root setting-rules MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-12" style="align-self: flex-start;">
                                <ul>
                                    <li>
                                        ${data.title}
                                    </li>
                                    <p>
                                        ${data.text}
                                    </p>
                                </ul>
                              </div>`
                            )}
                                </div>
                            </div>`
                        let temp = document.querySelector('.im-dialog-inner .items-section-single-item-content')
                        temp.innerHTML=newData
                    }).catch(error=>{
                    // console.log("failed")
                    // console.log(error.toString())
                    }
                )
            }
            break
            case 'privacy':
                axios.get(`app/${type}`)
                    .then(res => {
                        const {data}=res
                        this.props.settings(data,SETTINGS_RPIVACY)
                        const newData=
                        `
                        <div class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-direction-xs-column" id="second" style="flex: 1 1 0%;overflow-y: scroll; min-height: 0px;">
                           <div class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-flex-end"
                            <div class="MuiGrid-root setting-privacy MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-12" id="TTTTT" style="align-self: flex-start;overflow-y: scroll;color: #ffffff">
                                <p>
                                    ${data.text}
                                </p>
                            </div>
                            </div>
                        </div>
                        `
                        let temp = document.querySelector('.im-dialog-inner .items-section-single-item-content')
                        temp.innerHTML=newData
                    }).catch(error=>{
                    // console.log("failed")
                    // console.log(error.toString())
                    }
                )
            case 'support':
                axios.get(`app/${type}`)
                    .then(res => {
                        const {data}=res
                        this.props.settings(data,SETTINGS_SUPPORT)
                        const newData=
                            `<div class="MuiGrid-root setting-privacy MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-12" id="me" style="align-self: flex-start;">
                                <p>
                                    ${data.text}
                                </p>
                            </div>`
                        let temp = document.querySelector('.im-dialog-inner .items-section-single-item-content')
                        temp.innerHTML=newData
                    }).catch(error=>{
                    // console.log("failed")
                    // console.log(error.toString())
                    }
                )
        }
    }
    async componentDidMount() {
        // const {onClick}=this.props.data
        // await this.loadData(onClick)
        window.addMessage=()=>{
            const temp = document.querySelector('#input')
            if (temp.value.length < 5){
                this.handleSnack({ vertical: 'top', horizontal: 'center',snackMessage:'پیام کوتاه است' })
            }
            else{
                let dat=document.getElementById('appendHere')
                let wrapper= document.createElement('div');
                wrapper.innerHTML= `<div class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-flex-end">
                    <p class="setting-support-question">
                     ${temp.value}
                        <p class="setting-support-question-detail">
                      تاریخ     
                        </p>
                    </p>
                </div>`
                var div= wrapper.firstChild;
                dat.appendChild(div)
        }

        }
    }
    componentDidUpdate() {
        if (this.props.SettingsData.faq != null) {
            if (!this.state.faqLoaded) {
                this.setState({
                    faqLoaded: true
                })
            }
        } else if (this.props.SettingsData.privacy != null) {
            if (!this.state.privacyLoaded) {
                this.setState({
                    privacyLoaded: true
                })
            }
        } else if (this.props.SettingsData.rules != null) {
            if (!this.state.rulesLoaded) {
                this.setState({
                    rulesLoaded: true
                })
            }
        }
    }
    toggleClass = () => {
        const currentState = this.state.active;
        this.setState({ active: !currentState });
    }
    // addMessage=()=>{
    //   alert("awd")
    // }
    addMessage=()=>{

    }
    add= () => {
        return;
        if (!document.getElementById('appendHere'))
            return
        var wrapper= document.createElement('div');
        wrapper.innerHTML= '<div class="MuiGrid-root MuiGrid-container MuiGrid-item" id="me"><div class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center"><p class="setting-support-answer">false</p></div><div class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-flex-end"><p class="setting-support-question">متن پیام<p class="setting-support-question-detail">تاریخ</p></p></div></div>'
        var div= wrapper.firstChild;
        // console.log(div)
        let dat=document.getElementById('appendHere')
        dat.appendChild(div)
    }
    handleClick = (e,data,width) => {
        const dialog = document.createElement('div')
        dialog.classList.add('im-dialog')
        const html = e.target.closest('.items-section')
        const first = html.getBoundingClientRect()
        const closeDialog=()=> {
           this.props.toggleIndexNav('close')
           dialogInner.classList.remove('im-active')
           dialogInner.style.transform = `translate3d(${first.x - last.x}px, ${first.y - last.y}px, 0px) scaleX(1)`
           dialogInner.style.border = 'none'
           setTimeout(() => {
               dialog.remove()
           }, 350)
        }

        const dialogBackdrop = document.createElement('div')
        dialogBackdrop.classList.add('im-dialog-backdrop')
        dialogBackdrop.onclick = closeDialog
        dialog.appendChild(dialogBackdrop)

        const dialogInner = document.createElement('div')
        dialogInner.classList.add('im-dialog-inner')
        dialogInner.style.width = `${first.width}px`
        dialogInner.appendChild(html.cloneNode(true))
        // console.log("inner", dialogInner)
        const button = document.createElement('button')
        button.classList.add('im-dialog-close')
        button.innerHTML = `بازگشت`
        button.onclick = closeDialog
        dialogInner.appendChild(button)
        dialog.appendChild(dialogInner)

        document.body.appendChild(dialog)
        const last = dialogInner.getBoundingClientRect()
        dialogInner.style.transform = `translate3d(${first.x - last.x}px, ${first.y - last.y}px, 0px) scaleX(1)`
        requestAnimationFrame(() => {
            dialogInner.style.transform = ''
            dialogInner.style.transition = 'transform .3s ease-out'
            dialogInner.classList.add('im-active')
        })

        // e.target.parentElement.parentElement.style.width=`px`
        // e.target.parentElement.parentElement.classList.add('items-section-active')

    }
    handleSnack = (newState) => () => {
        console.log(...newState)
        this.setState({ open: true, ...newState },()=>{
            console.log(this.state)
        });
    };
    render() {
        const {data,fullHeight}=this.props
        const {id,onClick}=this.props.data

        const{faqLoaded, vertical, horizontal, open,snackMessage }=this.state
        return (
            <Grid item sm={12} justify={'center'}  container
                  id='iman'
            onClick={(e,data)=>{
                console.log(onClick)
                if (onClick!='/free' && onClick!='none')
                {
                    this.props.history.push(`/settings/${onClick}`)
                }
                return
                if (onClick!='/settings/free' && onClick!='none')
                {
                    var element = document.getElementById('iman');
                    var positionInfo = element.getBoundingClientRect();
                    var height = positionInfo.height;
                    var width = positionInfo.width;
                    this.props.toggleIndexNav('open')
                    this.handleClick(e,data,width)
                    this.loadData(onClick)
                }
            }}>
                {/*<p style={{position:'fixed',top:'50px',color:'red',fontSize:'50px',zIndex:'10000'}}>{String(this.state.faqLoaded)}</p>*/}
                <Grid container item sm={12} justify={'center'}
                      alignItems='flex-start' className='items-section'
                      style={{
                          height:fullHeight?'100%':''
                         }}>
                    <Grid className='items-section-single-item' item container
                        style={{backgroundColor:'transparent'}}
                    >
                        <img  src={BTN} className='items-section-single-item-background-image' alt=""/>
                        <Grid container justify={'center'} alignItems='center'
                              // className='items-section-single-item-bg-layer'
                              className='items-section-single-item-bg-layer'
                              // className={"items-section-single-item-bg-layer " + (this.state.active ? 'item-section-active' : '')}
                              style={{backgroundColor:data.bgColor}}
                              // onClick={this.toggleClass}
                        >
                            {
                                data.icon !=='' &&
                                <img className='items-section-single-item-bg-layer-icon' src={data.icon} alt=""/>
                            }
                            <p className='items-section-single-item-bg-layer-text' style={{color:data.textColor}} >
                                {data.text}
                            </p>
                        </Grid>
                    </Grid>
                    <Grid  className='items-section-single-item-content' item  container direction='column'
                           style={{
                               overflowY:'hidden'
                           }}
                           id='first'>
                        {/*faq Sample*/}
                        {/*<Grid  item container  id='second' direction='column' style={{flex:'1',minHeight:'0'}}>*/}
                        {/*    <Grid container alignItems={"flex-end"} style={{overflowY:'scroll',flex:'1'}} id='appendHere'>*/}
                        {/*        <Grid  id={"me"} direction={"column"} container item>*/}
                        {/*            <Grid justify={"flex-start"} container alignItems={"center"}>*/}
                        {/*                <p className='setting-support-answer'>*/}
                        {/*                    ا\راتور*/}
                        {/*                </p>*/}
                        {/*            </Grid>*/}
                        {/*            <Grid justify={"flex-end"} container alignItems={"center"}>*/}
                        {/*                <p className='setting-support-question' >*/}
                        {/*                    متن پیام*/}
                        {/*                    <p className='setting-support-question-detail'>*/}
                        {/*                        تاریخ*/}
                        {/*                    </p>*/}
                        {/*                </p>*/}
                        {/*            </Grid>*/}
                        {/*        </Grid>*/}
                        {/*    </Grid>*/}
                        {/*    <Grid justify={"center"} container id='toolbar' alignItems={"center"}>*/}
                        {/*        <Grid className='setting-support-input-section'  container xs={11} sm={11} alignItems={"center"} justify={"center"}>*/}
                        {/*            <Grid  className='setting-support-input-section-image-holder clickable' alignItems={"center"} container xs={2} sm={2}>*/}
                        {/*                <img src={SendIcon} style={{width:'100%'}} alt=""/>*/}
                        {/*            </Grid>*/}
                        {/*            <input type="text" style={{}} maxLength={10} placeholder={'پیغام خود را بنوسید'}/>*/}
                        {/*        </Grid>*/}
                        {/*    </Grid>*/}
                        {/*</Grid>*/}
                        {/*<Grid sm={12} xs={12} id={"me"} container item>*/}
                        {/*    <Grid style={{backgroundColor:'red'}} justify={"center"} container alignItems={"center"}>*/}
                        {/*        متن پیام*/}
                        {/*    </Grid>*/}
                        {/*    <Grid style={{backgroundColor:'blue'}} justify={"center"} container alignItems={"center"}>*/}
                        {/*        متن پیام*/}
                        {/*    </Grid>*/}
                        {/*</Grid>*/}
                        {/*<Grid justify={"center"} container alignItems={"center"}>*/}
                        {/*    <Grid className='setting-support-input-section'  container xs={11} sm={11} alignItems={"center"} justify={"center"}>*/}
                        {/*        <input type="text" style={{}} maxLength={10} placeholder={'پیغام خود را بنوسید'}/>*/}
                        {/*    </Grid>*/}
                        {/*</Grid>*/}
                        {/*<Grid justify={"center"} container alignItems={"center"} style={{marginTop:'20'}}>*/}
                        {/*    <Grid className='setting-support-input-section'  container xs={11} sm={11} alignItems={"center"} justify={"center"}>*/}
                        {/*        <input type="text" style={{}} maxLength={10} placeholder={'پیغام خود را بنوسید'}/>*/}
                        {/*    </Grid>*/}
                        {/*</Grid>*/}
                        {/*faq*/}



                        {/*rules*/}
                        {/*<Grid sm={12} className='setting-rules' xs={12} id={"me"} container item style={{alignSelf:'flex-start'}}>*/}
                        {/*    <ul>*/}
                        {/*        <li>text</li>*/}
                        {/*        <p>paragraph</p>*/}
                        {/*    </ul>*/}
                        {/*</Grid>*/}
                        {/*privacy*/}
                        {/*<Grid sm={12} className='setting-privacy' xs={12} id={"me"} container item style={{alignSelf:'flex-start'}}>*/}
                        {/*    <p>*/}
                        {/*        Lorem ipsum dolor sit amet, consectetur adipisicing elit. A corporis eius exercitationem minus nulla. Aliquam animi, at consectetur dolores ducimus ea, eligendi eos fuga maxime officiis perspiciatis reiciendis repellat sit.*/}
                        {/*    </p>*/}
                        {/*</Grid>*/}
                        {/*support*/}

                    </Grid>
                    <Snackbar
                        anchorOrigin={{ vertical, horizontal }}
                        open={open}
                        // onClose={handleClose}
                        message={snackMessage}
                        key={vertical + horizontal}
                    />
                </Grid>
            </Grid>
        )
    }
}

const mapStateToProps=state=>({
    SettingsData:state.Settings
})
export default connect(mapStateToProps,{settings})(withRouter(Item))
